import { gql } from '@apollo/client'
import { pathOr } from 'ramda'
import React from 'react'

import { usePromiseQuery } from '../../../utils/apollo/_helpers/promiseQuery'
import Select from '../../../packages/kiti/components/form/Select'
import { integrationsClient } from '../../../utils/apollo/api'

const QUERY = gql`
  query omieDocumentType($integrationId: Int, $page: Int) {
    omieDocumentType(integrationId: $integrationId, page: $page, limit: 9999) {
      codigo
      descricao
    }
  }
`

export const useDocumentTypeSelectLoader = filter => {
  const query = usePromiseQuery(QUERY, { client: integrationsClient })

  return (search, page = 1) => {
    return query({ search, page, ...filter })
      ?.then(pathOr([], ['data', 'omieDocumentType']))
      .then(data => {
        const result = data.map((item, index) => {
          return { id: item.codigo, name: item.descricao }
        })

        return result
      })
  }
}

const DocumentTypeSelect = ({ onChange, value, filter, ...props }) => {
  const getOptions = useDocumentTypeSelectLoader(filter)

  return <Select value={value} onChange={onChange} options={getOptions} {...props} />
}

export default DocumentTypeSelect
